/* RoboHelpComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter,
    Renderer = require("./RoboHelpRenderer"),
    _ = require("lodash");

class RoboHelpComponent extends EventEmitter {
    constructor(logger, router) {
        super();

        this._router = router;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    getCurrentSection() {
        let routeDetails = this._router.getRouteDetails();
        return _.get(routeDetails, "sln");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = RoboHelpComponent;
module.exports.$inject = ["$teve.logger", "$teve.router"];
